module.exports = __webpack_public_path__ + "static/media/X.931a998e.svg";